import styled from "styled-components";

import { ToolBarButton } from "./ToolBarButton";

interface IEditorDropdownProps {
  show?: boolean;
}

export const EditorDropdown = styled.div<IEditorDropdownProps>`
  display: block;

  position: absolute;
  top: 3rem;
  right: 0.5rem;

  border-radius: 0.25rem;
  min-height: 40px;

  transition: all 0.2s ease-in-out;
  padding: 0.75rem;

  z-index: ${({ show }) => (show ? "10000" : "-1")};
  opacity: ${({ show }) => (show ? "1" : "0")};
  background-color: ${({ theme }) => theme.groups.backgroundComponentsMural};
  pointer-events: ${({ show }) => (show ? "all" : "none")};
  transform: ${({ show }) => (show ? "translateX(0px)" : "translateX(10px)")};
  box-shadow: inset 0px 0px 0px 2px
    ${({ theme }) => theme.groups.borderColorComponentsMural};

  ${ToolBarButton} {
    width: 100%;

    .item-insert-file .text {
      width: fit-content;
    }

    .item-insert-file {
      margin: 0 0.5rem 0 0.5rem;
      padding: 0.5rem;
      color: ${({ theme }) => theme.lexicalEditor.fontPrimaryColor};
      cursor: pointer;
      line-height: 1rem;
      font-size: 1rem;
      display: flex;
      align-content: center;
      flex-direction: row;
      flex-shrink: 0;
      justify-content: space-between;
      background-color: ${({ theme }) => theme.lexicalEditor.modalBackground};
      border-radius: 0.25rem;
      border: 0;
      min-width: fit-content;
      max-width: 160px;
    }

    .active {
      display: flex;
      width: 1.25rem;
      height: 1.25rem;
      background-size: contain;
    }

    .text {
      display: flex;
      line-height: 1.25rem;
      flex-grow: 1;
      width: 200px;
    }
  }
`;
